import { render } from "./QRadio.vue?vue&type=template&id=5d36301a&scoped=true"
import script from "./QRadio.vue?vue&type=script&setup=true&lang=js"
export * from "./QRadio.vue?vue&type=script&setup=true&lang=js"

import "./QRadio.vue?vue&type=style&index=0&id=5d36301a&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d36301a"],['__file',"src/components/UI/buttons/QRadio.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5d36301a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5d36301a', __exports__)) {
    api.reload('5d36301a', __exports__)
  }
  
  module.hot.accept("./QRadio.vue?vue&type=template&id=5d36301a&scoped=true", () => {
    api.rerender('5d36301a', render)
  })

}


export default __exports__